import { LoadingChildrenBox } from '../../components/loadingChildrenBox';
import { LoadingChildren } from '../../components/loadingChildren';

interface ProfileHeaderProps {
  profileImageUrl: string;
  username?: string;
  isLoading: boolean;
  onImageError: (e: React.SyntheticEvent<HTMLImageElement>) => void;
}

/**
 * Profile header with image and username.
 */
export const ProfileHeader = ({
  profileImageUrl,
  username,
  isLoading,
  onImageError,
}: ProfileHeaderProps) => {
  return (
    <>
      <LoadingChildrenBox
        loading={isLoading}
        loadingElement={
          <div className="rounded-full object-cover h-28 w-28 m-auto animate-pulse bg-muted" />
        }
      >
        <img
          src={profileImageUrl}
          id="profile-image"
          alt={username}
          onError={onImageError}
          className="rounded-full object-cover h-28 w-28 m-auto"
        />
      </LoadingChildrenBox>
      <div className="mt-1 flex items-center justify-center">
        <LoadingChildren
          expectedChars={10}
          loadingClassName="mt-1 text-2xl/7 m-auto font-extrabold"
          loading={isLoading}
        >
          <h2 className="mt-1 text-2xl/7 text-center font-extrabold">{username}</h2>
        </LoadingChildren>
      </div>
    </>
  );
};
